module.exports = __webpack_public_path__ + "img/ad-banner.ac78921f.svg";